<template>
    <div class="eventManage_jsjb statisticalAnalysis">
        <div class="statisticalAnalysis_form">
            <div class="statisticalAnalysis_form_left">
                <div class="statisticalAnalysis_form_date">
                    <el-date-picker
                        v-model="daterange"
                        type="daterange"
                        range-separator="至"
                        value-format="YYYY-MM-DD"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                    />
                </div>
                <div class="statisticalAnalysis_form_select">
                    <el-select v-model="formSearch.depttypes_dic" multiple class="m-2" placeholder="请选择所属单位">
                        <el-option
                            label="中心"
                            value="zhzx"
                        />
                        <el-option
                            label="社区村"
                            value="sqc"
                        />
                        <el-option
                            label="科室"
                            value="ks"
                        />
                        <el-option
                            label="物业"
                            value="wy"
                        />
                    </el-select>
                </div>
                <div class="statisticalAnalysis_form_select">
                    <el-select v-model="formSearch.deptids_dic" multiple collapse-tags class="m-2" placeholder="请选择所属部门">
                        <el-option
                            v-for="item in ssbmOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </div>
            </div>
            <div class="statisticalAnalysis_form_right">
                <el-input
                    v-model="formSearch.name"
                    class="w-50 m-2"
                    placeholder="请输入姓名"
                    :prefix-icon="Search"
                />
                <div class="statisticalAnalysis_form_btn statisticalAnalysis_form_search" @click="searchFun">搜索</div>
                <div class="statisticalAnalysis_form_btn statisticalAnalysis_form_reset" @click="resetFun">重置</div>
            </div>
        </div>
        <div class="statisticalAnalysis_table">
            <div class="tableComponent" :style="{'height':tableMaxheight+'px'}">
                <!--:max-height="tableMaxheight"-->
                <el-table lazy :data="tableArray" :max-height="tableMaxheight" scrollbar-always-on="true"
                          style="width: 100%">
                    <el-table-column fixed align="center" label="序号" header-align="center" type="index" width="100">
                        <template #default="scope">
                            {{(formSearch.pageNum-1)*formSearch.pageSize + scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="用户名" min-width="8%"/>
                    <el-table-column prop="username" label="用户账号" min-width="10%"/>
                    <el-table-column prop="time" label="最近一次打卡时间" min-width="8%"/>
                    <el-table-column prop="dkdz" label="最近一次打卡地址" min-width="8%"/>
                    <el-table-column prop="depttype" label="所属单位" min-width="8%"/>
                    <el-table-column prop="deptname" label="所属部门" min-width="8%"/>
                    <el-table-column prop="dkcs" label="打卡次数" min-width="6%"/>
                    <el-table-column prop="sbgd" label="上报案件数量" min-width="8%"/>
                    <el-table-column prop="zczgd" label="自处置案件数量" min-width="8%"/>
                    <el-table-column prop="zxpdczgd" label="中心派单处置案件数量" min-width="10%"/>
                    <el-table-column align="center" header-align="center" min-width="6%">
                        <template
                            slot="header"
                            #header="scope"
                        >
                            <div class="opreate">
                                <span>操作</span>
                            </div>
                        </template>
                        <template #default="scope">
                            <el-button
                                type="text"
                                size="small"
                                @click.prevent="viewDetails(scope.row)"
                            >
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="jsjb_button">
                <div class="jsjb_button_list" @click="extExcel">
                    <i class="icon-file-excel"></i>导出
                </div>
                <div class="statisticalAnalysis_buttonPage">
                    <el-pagination
                        v-model:page-size="pageSize"
                        :page-sizes="[50, 100,150, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="rowsCount"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {reactive, onMounted, ref, watch, getCurrentInstance, nextTick} from 'vue'
    import {Search} from '@element-plus/icons-vue'
    import {useStore} from 'vuex'
    import qs from 'qs'
    import {ElLoading} from "element-plus";

    export default {
        name: "StatisticalAnalysis",
        setup() {
            const {proxy} = getCurrentInstance();
            const store = useStore();
            //搜索条件
            let daterange = ref([])
            let formSearch = reactive({
                name: "",
                daterang: "",
                deptids: "",
                deptids_dic:[],
                startTime: "",
                endTime: "",
                depttypes_dic:[],
                depttypes:"",
                pageNum: 1,
                pageSize: 10,
            })
            //所属部门
            let ssbmOptions = ref([])
            watch(() => daterange.value, (newVal) => {
                if (newVal) {
                    formSearch.startTime = newVal[0]
                    formSearch.endTime = newVal[1]
                } else {
                    formSearch.startTime = ""
                    formSearch.endTime = ""
                }
            })
            //表格
            let tableArray = ref()
            let tableMaxheight = ref()
            //计算表格最大高度
            const tableMaxheightFun = () => {
                setTimeout(() => {
                    const clientHeight = document.documentElement.clientHeight;
                    const clientWidth = document.documentElement.clientWidth
                    tableMaxheight.value = clientHeight - (48 + 48 + 36 + 56) * clientWidth / 1920;
                }, 0)
            }
            //分页
            let rowsCount = ref();
            const handleSizeChange = (param) => {
                formSearch.pageSize = param;
                tableData()
            }
            const handleCurrentChange = (param) => {
                formSearch.pageNum = param;
                tableData()
            }
            //查询表格数据
            const tableData = () => {
                formSearch.deptids = formSearch.deptids_dic.length>0? [...formSearch.deptids_dic].join(","):"";
                formSearch.depttypes =formSearch.depttypes_dic.length>0? [...formSearch.depttypes_dic].join(","):'';
                proxy.$axios.post("/jgfast/wgsj/selWgsjClockinGr", formSearch).then((res) => {
                    tableArray.value = res.data.vbs;
                    rowsCount.value = res.data.rowsCount
                });
            }
            //查看点击事件
            const viewDetails = (param) => {
                store.commit('addLeftTreeToHeaderTab', {
                    name: "ViewStatisticalAnalysis",
                    label: "打卡详情-" + param.username,
                    linkTo: "/ViewStatisticalAnalysis",
                    query: {
                        userid: param.userid
                    },
                });
            }
            const searchFun = () => {

                tableData();
            }
            const resetFun = () => {
                formSearch.name = "";
                // daterange.value = "";
                formSearch.depttypes = "";
                formSearch.deptids = "";
                defaultTime();
                tableData();
            }
            //导出excel
            const extExcel = () => {
                let  loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                })

                var params = {
                    _u: "fast-wgsj-dkkq-gr.xml",
                    endTime: formSearch.endTime,
                    startTime: formSearch.startTime,
                    name: formSearch.name,
                }
                proxy.$axios.own.get('/jgfast/ureport/excel?' + qs.stringify(params), {
                    // params: params,
                    responseType: 'blob'   //首先设置responseType字段格式为 blob
                }).then(res => {
                    let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}); // 为blob设置文件类型，这里以.xlsx为例
                    let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = '考勤统计列表.xlsx';
                    a.click();
                    // 释放这个临时的对象url
                    window.URL.revokeObjectURL(url);
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            }
            onMounted(() => {
                proxy.$axios.post("/jgfast/sys/comp/selUserComp").then((res) => {
                    ssbmOptions.value = res.data;
                });
                tableMaxheightFun()
                defaultTime();
                window.addEventListener('resize', () => tableMaxheightFun(), true);
                tableData();

            });
            //默认时间
            const defaultTime = () => {
                let time1 = new Date();
                // let year = time1.getFullYear();
                // let month = (time1.getMonth() + 1) < 10 ? "0" + (time1.getMonth() + 1) : (time1.getMonth() + 1);
                // let day1 = time1.getDate() < 10 ? "0" + time1.getDate() : time1.getDate();
                // let hour = time1.getHours()<10?"0"+time1.getHours():time1.getHours(); //得到小时
                // let minu = time1.getMinutes()<10?"0"+time1.getMinutes():time1.getMinutes(); //得到分钟
                // let datetimerange1 = year + "-" + month + "-" + day1
                let time2 = new Date();
                let num2 = time1.getDay() == 6 ? 0 : 1 + time1.getDay();
                time2.setTime(time1.getTime() - 3600 * 24 * 1000 * num2);
                let year2 = time2.getFullYear();
                let month2 = (time2.getMonth() + 1) < 10 ? "0" + (time2.getMonth() + 1) : (time2.getMonth() + 1);
                let day2 = time2.getDate() < 10 ? "0" + time2.getDate() : time2.getDate();
                let datetimerange2 = year2 + "-" + month2 + "-" + day2;

                let time3 = new Date();
                let num3 = time1.getDay() == 6 ? 6 : 5 - time1.getDay();
                time3.setTime(time1.getTime() + 3600 * 24 * 1000 * num3);
                let year3 = time3.getFullYear();
                let month3 = (time3.getMonth() + 1) < 10 ? "0" + (time3.getMonth() + 1) : (time3.getMonth() + 1);
                let day3 = time3.getDate() < 10 ? "0" + time3.getDate() : time3.getDate();
                let datetimerange3 = year3 + "-" + month3 + "-" + day3

                daterange.value[0] = datetimerange2;
                daterange.value[1] = datetimerange3;
                formSearch.startTime = datetimerange2
                formSearch.endTime = datetimerange3;
            }
            //分
            return {
                formSearch,
                Search,
                daterange,
                rowsCount,
                tableArray,
                handleSizeChange,
                handleCurrentChange,
                tableMaxheight,
                viewDetails,
                searchFun,
                resetFun,
                extExcel,
                ssbmOptions
            }
        }
    }
</script>

<style scoped>

</style>
